memoizedSelection